import React from 'react'
import { Icon } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  titleStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '2rem 2rem 0 2rem',
    '& :first-child': {
      fontSize: 'large',
      fontWeight: '600',
      color: '#064e75',
    },
  },
  iconStyle: {
    marginRight: '1rem',
    cursor: 'pointer',
    fontSize: 'initial',
    color: '#064e75',
    fontWeight: '600',
  },
}))

const MetricsDialogHeader = ({ title, iconName, handleClose }) => {
  const classes = useStyles()
  return (
    <div id="subscribers-list" className={classes.titleStyle}>
      <span> {title}</span>
      <Icon onClick={handleClose} className={classes.iconStyle}>
        {iconName}
      </Icon>
    </div>
  )
}

export default MetricsDialogHeader
